
var id = "changeIntegral";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"changeIntegral\">\n<style type=\"text/css\">\n\t#changeIntegral .st0{fill:none;stroke:#1B60AD;stroke-width:1.5;}\n\t#changeIntegral .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1B60AD;}\n</style>\n<circle id=\"changeIntegral_椭圆形\" class=\"st0\" cx=\"8\" cy=\"8\" r=\"7.2\" />\n<g>\n\t<g transform=\"translate(3.000000, 4.000000)\">\n\t\t<g>\n\t\t\t<path class=\"st1\" d=\"M3.4,1.1H2.2v2.2H0v1.1h2.2v2.2h1.1V4.5h2.2V3.4H3.4V1.1z M9,7.3H7.9v-6L6.2,1.9V1l2.6-1H9V7.3z\" />\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
